//用户数据验证接口
import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs';

function errorCreat (msg) {
    const err = new Error(msg)
    throw err
}

const service = axios.create({
    baseURL: '',
    timeout: 15000 // 请求超时时间
})

service.interceptors.request.use(
    config => {
        // 在请求发送之前做一些处理
        //if (!(/^https:\/\/|http:\/\//.test(config.url))) {
            //config.headers['username'] = '57O757uf566h55CG5ZGY'
        //}
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.data = qs.stringify({
            ...config.data
        })
        return config
    },
    error => {
        // 发送失败
        console.log(error)
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data
        // 这个状态码是和后端约定的
        const { code } = dataAxios
        // 根据 code 进行判断
        if (code === undefined) {
            // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
            return dataAxios
        } else {
            // 有 code 代表这是一个后端接口 可以进行进一步的判断
            switch (code) {
                case 0:
                    // [ 示例 ] code === 0 代表没有错误
                    return dataAxios.data
                case -1:
                    // [ 示例 ] 其它和后台约定的 code
                    Message({
                        message: '用户名密码错误',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    errorCreat(`[ code: code ] ${dataAxios.msg}: ${response.config.url}`)
                    break
                default:
                    // 不是正确的 code
                    errorCreat(`${dataAxios.msg}: ${response.config.url}`)
                    break
            }
        }
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 400: error.message = '请求错误'; break
                case 401: error.message = '未授权，请登录'; break
                case 403: error.message = '拒绝访问'; break
                case 404: error.message = `请求地址出错: ${error.response.config.url}`; break
                case 408: error.message = '请求超时'; break
                case 500: error.message = '服务器内部错误'; break
                case 501: error.message = '服务未实现'; break
                case 502: error.message = '网关错误'; break
                case 503: error.message = '服务不可用'; break
                case 504: error.message = '网关超时'; break
                case 505: error.message = 'HTTP版本不受支持'; break
                default: break
            }
        }
        return Promise.reject(error)
    }
)
export default service


// WEBPACK FOOTER //
// ./src/request/empiAxios.js